export enum NotifyPriorities {
  HIGH = "HIGH",
  LOW = "LOW",
}
